/** A sent custom email (row in the email-history list). Maps EmailMessageResource (PascalCase). */
export default class EmailHistoryItem {
  id: number

  subject: string

  htmlBody: string

  scope: number // EmailRecipientScopeEnum: 1=single institution, 2=all approved

  senderEmail: string

  statusId: number // EmailMessageStatusEnum: 1=pending,2=inProgress,3=completed,4=completedWithErrors

  totalRecipients: number

  sentCount: number

  failedCount: number

  createdAt?: Date

  sentAt?: Date

  attachmentNames: string[]

  constructor(m: any) {
    this.id = m.Id
    this.subject = m.Subject
    this.htmlBody = m.HtmlBody
    this.scope = m.Scope
    this.senderEmail = m.SenderEmail
    this.statusId = m.StatusId
    this.totalRecipients = m.TotalRecipients
    this.sentCount = m.SentCount
    this.failedCount = m.FailedCount
    this.createdAt = m.CreatedAt ? new Date(m.CreatedAt) : undefined
    this.sentAt = m.SentAt ? new Date(m.SentAt) : undefined
    this.attachmentNames = m.AttachmentNames || []
  }
}
